import { render, staticRenderFns } from "./CreatePicklPage.vue?vue&type=template&id=adf9299c&scoped=true&"
import script from "./CreatePicklPage.vue?vue&type=script&lang=ts&"
export * from "./CreatePicklPage.vue?vue&type=script&lang=ts&"
import style0 from "./CreatePicklPage.vue?vue&type=style&index=0&id=adf9299c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adf9299c",
  null
  
)

export default component.exports